import { Star, Quote } from "lucide-react";
import Reveal from "./Reveal";
import { LINKS } from "./data";

const testimonials = [
  {
    name: "Fred",
    location: "Round Rock, TX",
    rating: 5,
    quote:
      "Our AC quit on one of the hottest days of the summer and Bill had someone out to us fast. It turned out to be a smaller fix than I feared, and he could have sold me a lot more but didn't. Honest, fair, and quick. Highly recommend Million-Air.",
  },
  {
    name: "Jackie & Mike",
    location: "Austin, TX",
    rating: 5,
    quote:
      "We finally replaced our old system and went with Million-Air after getting a few quotes. Bill walked us through the options without any pressure, and the American Standard unit he installed has been running great. They showed up on time, cleaned up after themselves, and the final price matched the quote exactly. These folks clearly know what they're doing.",
  },
  {
    name: "Pete",
    location: "Round Rock, TX",
    rating: 5,
    quote:
      "We've used Million-Air for both our AC and heating for years, and they're the only company we call. Bill is straight with you every time, whether it's a quick tune-up or a bigger repair. This past Winter our heat went out and they had us warm again the same day. It's rare to find a company that treats you like a neighbor instead of a sales target. Trustworthy, dependable, and genuinely good people.",
  },
];

function Stars({ n }) {
  return (
    <div className="flex gap-1" aria-label={`${n} star rating`}>
      {Array.from({ length: 5 }).map((_, i) => (
        <Star key={i} size={18} className={i < n ? "fill-[#C9A44C] text-[#C9A44C]" : "text-[#9AA3AF]/40"} />
      ))}
    </div>
  );
}

export default function Reviews() {
  return (
    <section id="reviews" className="relative bg-[#171B22] py-24 md:py-32">
      <div className="max-w-[1200px] mx-auto px-5 lg:px-10">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <img src="/markonlyvector.png" alt="" className="h-6 w-auto opacity-80" />
                <span className="text-xs tracking-[0.25em] uppercase text-[#9AA3AF]">Reviews</span>
              </div>
              <h2 className="text-3xl md:text-5xl text-[#C9A44C] max-w-2xl">
                Kind words from the people we keep comfortable.
              </h2>
            </div>
            <a
              data-testid="google-review-btn"
              href={LINKS.GOOGLE_REVIEW_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="focus-gold shrink-0 inline-flex items-center gap-2 px-7 py-4 rounded-full font-bold bg-[#C9A44C] text-[#171B22] hover:bg-[#D6B15A] hover:-translate-y-0.5 transition-[background-color,transform] duration-300"
            >
              Leave Us a Google Review
            </a>
          </div>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <Reveal key={i} delay={i * 0.08} className="h-full">
              <div
                data-testid={`review-card-${i}`}
                className="h-full rounded-2xl bg-[#101317] border border-[#9AA3AF]/15 p-7 hover:border-[#C9A44C]/40 hover:-translate-y-1.5 transition-[transform,border-color] duration-400"
              >
                <Quote className="text-[#C9A44C]/50 mb-4" size={30} />
                <p className="text-white/90 text-base leading-relaxed">{t.quote}</p>
                <div className="hairline my-5" />
                <div className="flex items-center justify-between gap-3">
                  <div>
                    <div className="text-white">{t.name}</div>
                    <div className="text-sm text-[#9AA3AF]">{t.location}</div>
                  </div>
                  <Stars n={t.rating} />
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
